<template>
  <div class="settings" v-if="data" v-loading="isLoading">
    <div class="filter">
      <div class="header-button">
        <el-button size="mini" type="success" @click="editSettingHandle">更新</el-button>
      </div>
      <div class="header-button">
        <el-button size="mini" type="primary" @click="clearScreen">クリア</el-button>
      </div>
    </div>
    <div class="setting-content">
      <el-form label-position="right" size="mini" :model="form" label-width="300px">
        <el-form-item label="API TOKEN有効時間(分)" v-if="!isGroupMode" :error="errors.apiTokenExpiredTime">
          <el-input v-model="form.apiTokenExpiredTime"></el-input>
        </el-form-item>
        <el-form-item label="CSVデータの文字コード" :error="errors.csvFileEncoding">
          <el-select v-model="form.csvFileEncoding">
            <el-option
              v-for="item in csvFileEncoding"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="表示アレルギー区分" v-if="!isGroupMode && hasCrmLicense" :error="errors.showAllergy">
          <el-select v-model="form.showAllergy">
            <el-option
              v-for="item in showAllergy"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="data.label.customerPerPage" v-if="!isGroupMode && hasCrmLicense" :error="errors.customerPerPage">
          <el-select v-model="form.customerPerPage">
            <el-option
              v-for="item in customerPerPage"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通貨単位">
          <el-input v-model="data.static.currencyName" disabled></el-input>
        </el-form-item>
        <el-form-item label="顧客登録数 / 顧客登録上限" v-if="hasCrmLicense">
          <el-input :value="data.static.customerNum + ' / ' + data.static.customerLimit" disabled></el-input>
        </el-form-item>
        <el-form-item label="顧客登録数 / 顧客登録上限(グループ全体)"  v-if="!isGroupMode && data.static.groupCustomerNum && hasCrmLicense">
          <el-input :value="data.static.groupCustomerNum + ' / ' + data.static.groupCustomerLimit" disabled></el-input>
        </el-form-item>
        <template v-if="data.static.hasPermCsvExport && !isGroupMode">
          <el-form-item :label="data.label.outputHeader" :error="errors.outputHeader">
            <el-checkbox v-model="form.outputHeader"></el-checkbox>
          </el-form-item>
          <el-form-item :label="data.label.outputTitle" :error="errors.outputTitle">
            <el-checkbox v-model="form.outputTitle"></el-checkbox>
          </el-form-item>
          <el-form-item :label="data.label.title" :error="errors.title">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item :label="data.label.outputCategory" :error="errors.outputCategory">
            <el-checkbox v-model="form.outputCategory"></el-checkbox>
          </el-form-item>
          <el-form-item :label="data.label.category" :error="errors.category">
            <el-input v-model="form.category"></el-input>
          </el-form-item>
          <el-form-item :label="data.label.csvDatetimeFormat" :error="errors.csvDatetimeFormat">
            <el-input v-model="form.csvDatetimeFormat"></el-input>
            <span class="help_text">{{ data.helpText.csvDatetimeFormat }}</span>
          </el-form-item>
        </template>
        <el-form-item :label="data.label.changeDateHour" v-if="!isGroupMode" :error="errors.changeDateHour">
          <el-input v-model="form.changeDateHour"></el-input>
        </el-form-item>
        <el-form-item :label="data.label.seat" v-if="!isGroupMode" :error="errors.seat">
          <el-input v-model="form.seat"></el-input>
        </el-form-item>

        <el-form-item label="予算算出方法" v-if="isGroupMode" :error="errors.budgetCalculateMethod">
          <el-select v-model="form.budgetCalculateMethod">
            <el-option
              v-for="item in budgetCalculateMethod"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="集計データ再計算">
          <el-button size="mini" type="success" icon="el-icon-refresh" @click="shopCalculateBill"></el-button>
          <span class="help_text">毎日朝5時に自動的に集計されます</span>
        </el-form-item>
        <el-form-item label="プロモーション集計データ再計算" v-if="hasCrmLicense">
          <el-button size="mini" type="success" icon="el-icon-refresh" @click="shopCalculatePromotion"></el-button>
          <!-- <span class="help_text">毎日朝5時に自動的に集計されます</span> -->
        </el-form-item>
        <el-form-item label="顧客年代情報再計算" v-if="hasCrmLicense">
          <el-button size="mini" type="success" icon="el-icon-refresh" @click="shopSetCustomerAge"></el-button>
          <span class="help_text">顧客の誕生日情報から年代を更新します(毎日朝5時に自動的に更新されます)</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import $ from 'jquery'
import _ from 'lodash'
export default {
  name: 'Settings',
  data () {
    return {
      data: false,
      csvFileEncoding: [
        {value: 1, label: 'SJIS'},
        {value: 2, label: 'EUC-JP'},
        {value: 3, label: 'UTF-8'},
        {value: 5, label: 'UTF-8 (BOM付き)'},
        {value: 6, label: 'UTF-16LE'},
        {value: 4, label: 'JIS'},
      ],
      showAllergy: [
        {value: 1, label: '必須項目のみ'},
        {value: 2, label: '必須 + 推奨項目'},
      ],
      customerPerPage: [
        {value: 100, label: '100'},
        {value: 200, label: '200'},
        {value: 300, label: '300'},
        {value: 400, label: '400'},
        {value: 500, label: '500'},
        {value: 600, label: '600'},
        {value: 700, label: '700'},
      ],
      budgetCalculateMethod: [
        {value: 1, label: '店舗足し上げ'},
        {value: 2, label: '独自設定'},
      ],
      form: {},
      errors: {
        apiTokenExpiredTime: '',
        csvFileEncoding: '',
        showAllergy: '',
        customerPerPage: '',
        outputHeader: '',
        outputTitle: '',
        title: '',
        outputCategory: '',
        category: '',
        csvDatetimeFormat: '',
        changeDateHour: '',
        seat: '',
        budgetCalculateMethod: '',
      },
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters('account', [
      'asShop',
      'isGroupMode',
      'hasCrmLicense',
    ]),
    screenData: function () {
      return this.orgData
    },
  },
  watch: {
    asShop (val) {
      this.fetchData()
    },
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.$request.settings.getSettings().then(res => {
        let result = res.body
        if (result) {
          this.data = result
          this.form = _.cloneDeep(result.settings)
        }

        console.log(res)
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    clearScreen () {
      this.form = _.cloneDeep(this.data.settings)
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = ''
      })
    },
    showErrorHandle (key, msg) {
      let obj = $(key)
      obj.html(msg)
      obj.show().fadeOut(3000)
    },
    editSettingHandle () {
      this.isLoading = true
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = ''
      })
      this.$request.settings.editSettings(this.form).then(res => {
        let result = res.body
        if (result.settings) {
          this.data.settings = result.settings
        }
        this.$message({
          message: '更新しました。',
        })
        console.log(res)
      }, err => {
        const body = err.response.body
        this.$parent.$emit('requestError', [body, this.errors])
      }).finally(() => {
        this.isLoading = false
      })
    },
    shopCalculateBill () {
      this.isLoading = true
      this.form._shop = this.form.shop
      this.$request.settings.shopCalculateBill(this.form).then(res => {
        this.$message({
          message: '更新しました。',
        })
        console.log(res)
      }, err => {
        const body = err.response.body
        this.$parent.$emit('requestError', [body, this.errors])
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    shopCalculatePromotion () {
      this.isLoading = true
      this.form._shop = this.form.shop
      this.$request.settings.shopCalculatePromotion(this.form).then(res => {
        this.$message({
          message: '更新しました。',
        })
        console.log(res)
      }, err => {
        const body = err.response.body
        this.$parent.$emit('requestError', [body, this.errors])
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    shopSetCustomerAge () {
      this.isLoading = true
      this.form._shop = this.form.shop
      this.$request.settings.shopSetCustomerAge(this.form).then(res => {
        this.$message({
          message: '更新しました。',
        })
        console.log(res)
      }, err => {
        const body = err.response.body
        this.$parent.$emit('requestError', [body, this.errors])
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
  mounted () {
    this.fetchData()
  },
}
</script>

<style lang="sass" scoped>
@import "static/sass/variables.sass"
@import "static/sass/report/common.sass"

.header-button
  float: right
  padding-right: 20px
  padding-top: 12px

.setting-content
  background-color: #FFF
  padding-left: 12%
  padding: 12px 0px 12px 12%

.el-input,
.el-select
  width: 300px

.error
  color: $error-color
  margin-left: 10px
  display: none

.help_text
  color: $secondary-color
</style>



// WEBPACK FOOTER //
// src/components/Report/Settings.vue